"use strict";

module.exports = function (accumulator, order, product, component) {
  if (component.quantity < 5) {
    return accumulator + '\nDO NOT SHRINK\n';
  }

  return accumulator;
};